<div class="runSetup run-setup-container" [class.print-view]="isPrintView">
  <div class="run-setup-body">
    @if (isPrintView) {
    <app-print-preview-bar
      viewName="Run Setup"
      [studyName]="studyName"
      [contextLine]="printContextLine"
      [tableColumns]="tableColumns"
      (selectColumns)="handleSelectColumns($event)"></app-print-preview-bar>
    }
    @if (runSetupFormGroup) {
    <div class="bpx-toolbar run-setup-actions" *ngIf="!isPrintView">
      <div class="bpx-toolbar__actions">
        @if (shouldShowSetupAdjustmentButton()) {
        <button type="button" class="bpx-btn" (click)="handleSetupAdjustment()">
          Setup adjustment
        </button>
        <span class="bpx-toolbar__sep"></span>
        }
        <button type="button" class="bpx-btn" [disabled]="(isStudySaved$ | async) !== true" (click)="navigateToPrintView()">
          <mat-icon fontIcon="print"></mat-icon>
          <span>Print View</span>
        </button>
      </div>
    </div>
    <div class="bpx-scroll-card run-setup-scroll">
      <div class="run-setup-form-section" *ngIf="!isPrintView">
        <div class="bpx-toolbar run-setup-fields">
          <div class="bpx-control run-setup-select">
            <span class="bpx-control__label" id="run-setup-test-spec-label">Test Spec</span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
              <mat-select class="sel" [(value)]="selectedTestSpec" (selectionChange)="handleTestSpecSelectionChange($event)"
                aria-labelledby="run-setup-test-spec-label">
                @for (testSpec of testSpecs; track testSpec) {
                <mat-option [value]="testSpec">{{testSpec}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="bpx-control run-setup-select">
            <span class="bpx-control__label" id="run-setup-assign-spec-label">Assignment Spec</span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
              <mat-select class="sel" [value]="selectedAssignSpec ?? 'Final'"
                (selectionChange)="handleAssignSpecSelectionChange($event)"
                aria-labelledby="run-setup-assign-spec-label">
                @for (assignSpec of assignSpecs; track assignSpec) {
                <mat-option [value]="assignSpec">{{assignSpec}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="bpx-control run-setup-select">
            <span class="bpx-control__label" id="run-setup-kit-lot-label">Reference Lot</span>
            <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field">
              <mat-select class="sel" [(value)]="selectedKitLot" (selectionChange)="handleKitLotSelectionChange($event)"
                aria-labelledby="run-setup-kit-lot-label">
                <mat-option [value]="''">N/A</mat-option>
                @for (kitLot of kitLots; track kitLot) {
                <mat-option [value]="kitLot">{{kitLot}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="run-setup-toggles">
            <mat-checkbox class="show-means-toggle" color="primary" [checked]="calculateAverages"
              (change)="handleCalculateAveragesChange($event)">
              Show Means
            </mat-checkbox>
            <mat-checkbox class="skip-missing-samples-toggle" color="primary" [checked]="skipMissingSamples"
              (change)="handleSkipMissingSamplesChange($event)">
              Missing Patient Samples
            </mat-checkbox>
            <!--
            <mat-checkbox class="legacy-4pl-toggle" color="primary" [checked]="useLegacy4pl"
              (change)="handleUseLegacy4plChange($event)">
              Use Legacy 4pl
            </mat-checkbox>
            <!-- Optimize Adjustment toggle moved to Calibration > Adjusted Calibrator tab -->
          </div>
        </div>
        <div class="bpx-control run-setup-comment">
          <span class="bpx-control__label" id="run-setup-comments-label">Comments</span>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="bpx-field bpx-field--textarea">
            <textarea matInput placeholder="Study Notes..." aria-labelledby="run-setup-comments-label"
              [(ngModel)]="studyComment" (ngModelChange)="handleCommentsChange($event)"></textarea>
          </mat-form-field>
        </div>
      </div>

      <div class="flex accessionKitTable">
        <div class="run-setup-tables">
          <div *ngIf="runSetupFormGroup?.get('runSamples')" [formGroup]="runSetupFormGroup" class="run-samples-table">
            @if (!isPrintView) {
            <div class="bpx-section__head">
              <h3 class="bpx-section__title">Run Samples</h3>
              <span class="bpx-section__count">{{ runSamplesDataSource ? runSamplesDataSource.data.length : 0 }} samples</span>
            </div>
            }
            <div class="run-samples-card" [class.bpx-table]="!isPrintView" [class.bpx-table--frame]="!isPrintView">
            <!-- data-bpx-fill-scroll scrolls the worklist when a fill drag reaches its edge, so a
                 value can be filled past the rows in view. See FillHandleDirective. -->
            <table #runSamplesTable id="run-samples" mat-table [dataSource]="runSamplesDataSource" [trackBy]="trackRunSample"
              formArrayName="runSamples" data-bpx-fill-scroll>
              <ng-container matColumnDef="Accession">
                <th mat-header-cell *matHeaderCellDef>Accession</th>
                <td mat-cell *matCellDef="let element">{{element.accessionId}}</td>
              </ng-container>

              @if (isPrintView) {
              <ng-container matColumnDef="Sample ID">
                <th mat-header-cell *matHeaderCellDef>Sample ID</th>
                <td mat-cell *matCellDef="let element; let rowIndex = index" class="text-centered">
                  {{ getRunSamplePrintSampleId(element, rowIndex) }}
                </td>
              </ng-container>
              } @else {
              <ng-container matColumnDef="Sample ID">
                <th mat-header-cell *matHeaderCellDef>Sample ID</th>
                <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex + (pageIndex * pageSize)"
                  [bpxFillHandle]="runSamplesFormArray.at(rowIndex + pageIndex * pageSize).get('sampleId')">
                  <input matInput formControlName="sampleId" class="text-input text-centered" />
                </td>
              </ng-container>
              }

              @if (isPrintView) {
              <ng-container matColumnDef="Sample Type">
                <th mat-header-cell *matHeaderCellDef>Sample Type</th>
                <td mat-cell *matCellDef="let element; let rowIndex = index">
                  {{ getRunSamplePrintSampleType(element, rowIndex) }}
                </td>
              </ng-container>
              } @else {
              <ng-container matColumnDef="Sample Type">
                <th mat-header-cell *matHeaderCellDef>Sample Type</th>
                <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex + (pageIndex * pageSize)"
                  [bpxFillHandle]="runSamplesFormArray.at(rowIndex + pageIndex * pageSize).get('sampleType')">
                  <mat-select class="drop-down-field text-input" formControlName="sampleType">
                    @for (sampleType of sampleTypes; track sampleType) {
                    <mat-option class="optionWidth" [value]="sampleType" [matTooltip]="sampleType"
                      matTooltipPosition="above">{{sampleType}}</mat-option>
                    }
                  </mat-select>
                </td>
              </ng-container>
              }

              @if (isPrintView) {
              <ng-container matColumnDef="Req Num Replicates">
                <th mat-header-cell *matHeaderCellDef>
                  <span class="req-num-replicates-print-label">Req Num<br />Replicates</span>
                </th>
                <td mat-cell *matCellDef="let element; let rowIndex = index" class="text-centered">
                  {{ getRunSamplePrintReplicates(element, rowIndex) }}
                </td>
              </ng-container>
              } @else {
              <ng-container matColumnDef="Req Num Replicates">
                <th mat-header-cell *matHeaderCellDef>Req Num Replicates</th>
                <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex + (pageIndex * pageSize)"
                  [bpxFillHandle]="runSamplesFormArray.at(rowIndex + pageIndex * pageSize).get('reqNumReplicates')">
                  <input matInput formControlName="reqNumReplicates" integerOnly
                    class="text-input req-num-replicates-field text-centered" />
                </td>
              </ng-container>
              }

              @for (lotColumn of reagentLotColumns; track lotColumn) {
              <ng-container [matColumnDef]="lotColumn">
                <th mat-header-cell *matHeaderCellDef class="lot-column-header">
                  <span class="lot-column-header__instrument">{{ reagentLotColumnMeta[lotColumn]?.instrumentId }}</span>
                  <span class="lot-column-header__lot">{{ reagentLotColumnMeta[lotColumn]?.lot }}</span>
                </th>
                <td mat-cell *matCellDef="let element; let rowIndex = index" class="lot-column-cell"
                  [ngClass]="{ 'lot-over-limit': isReagentLotUnderrun(lotColumn, rowIndex) }">
                  {{ getReagentLotValue(lotColumn, rowIndex) }}
                </td>
              </ng-container>
              }

              <tr mat-header-row *matHeaderRowDef="displayedRunSamplesColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedRunSamplesColumns;"></tr>
            </table>
            @if (!isPrintView && !(runSamplesDataSource && runSamplesDataSource.data.length)) {
            <p class="bpx-empty">No run samples for this study.</p>
            }
            </div>
          </div>
          <!-- Missing samples summary table temporarily disabled
          <div class="missing-samples-container" *ngIf="tabIndex === 0 && missingSamples?.length">
            <table mat-table [dataSource]="missingSamples" class="missingTable">
              <ng-container *ngFor="let column of displayedColumnsMissing" [matColumnDef]="column">
                <ng-container *ngIf="column === 'Sample ID'">
                  <th mat-header-cell *matHeaderCellDef> {{ column }} </th>
                  <td mat-cell *matCellDef="let element"> {{element}} </td>
                </ng-container>
                <ng-container *ngIf="column !== 'Sample ID'">
                  <th mat-header-cell *matHeaderCellDef> {{ column }} </th>
                  <td mat-cell *matCellDef="let element"> {{getMissingValues(column, element)}} </td>
                </ng-container>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumnsMissing"></tr>
              <tr mat-row *matRowDef="let row; columns:displayedColumnsMissing"></tr>
            </table>
          </div>
          -->
        </div>
      </div>
    </div>
    } @else if (isEmpty) {
    <div class="loading-container">
      <div class="mb-6">No data found</div>
    </div>
    } @else {
    <div class="loading-container">
      <div><mat-spinner class="spinner"></mat-spinner></div>
      <div>Loading...</div>
    </div>
    }
  </div>
  @if (isPrintView) {
  <div class="run-setup-print-footer">
    <div>{{ studyName || '-' }}</div>
    <div>{{ panelName || '-' }} : Spec Rev {{ specVersion || '-' }}</div>
    <div>Web App Version: {{ appVersion || '-' }}</div>
  </div>
  }
</div>
